/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ period: NonNullable<unknown> }} Partner_Admin_Commission_From_PeriodInputs */



/**
* | output |
* | --- |
* | "You came from {period}" |
*
* @param {Partner_Admin_Commission_From_PeriodInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_from_period = /** @type {((inputs: Partner_Admin_Commission_From_PeriodInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_From_PeriodInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Sie kamen von ${i?.period}`)
	return /** @type {LocalizedString} */ (`You came from ${i?.period}`)
});